export default {
  navbar: {
    home: 'Inicio',
    services: 'Servicios',
    portfolio: 'Portfolio',
    blog: 'Blog',
    contact: 'Contacto',
  },
  hero: {
    marketing_ai: 'Marketing, Automatización y AI',
    atemporal: 'Atemporal',
    title: 'Marketing Estratégico.<br />Innovación Real.',
    description: 'Nos asociamos con marcas con visión de futuro para acelerar su crecimiento. Nuestro enfoque combina el análisis de datos con creatividad de alto impacto y ejecución tecnológica de vanguardia.',
  },
  portfolio: {
    subtitle: 'Portfolio',
    title: 'Proyectos',
    highlight: 'Destacados',
    description: 'Estrategias de impacto y casos de éxito en marketing',
    projects: {
      mia_astral: 'Mia Astral',
      erika_de_la_vega: 'Erika De La Vega',
      ismael_cala: 'Ismael Cala',
      foto_ahora: 'Foto Ahora',
      nawis_app: 'Nawis App',
      pfs_realty: 'PFS Realty',
      yogurt_boom: 'Yogurt Boom',
      runahr: 'Runa',
      wide_angle: 'Wide Angle',
      cachalo_y_gana: 'Cachalo y Gana',
      xcape: 'Xcape',
    },
    category: 'Caso de Éxito',
  },
  services: {
    meta: {
      title: 'Servicios de Marketing Digital | Estrategia, E-commerce y Leads | Mood Agency',
      description: 'Ofrecemos servicios integrales de marketing digital: estrategia de negocios, generación de leads, e-commerce, infraestructura cloud y experiencia del cliente para escalar tu marca.',
      keywords: 'marketing digital, estrategia digital, e-commerce, generación de leads, transformación digital, consultoría digital, mood agency',
    },
    subtitle: 'Lo que impulsamos',
    title: 'Servicios',
    highlight: 'Estratégicos',
    description: 'Fusionamos la inteligencia del marketing con la agilidad de la innovación para crear soluciones que no solo resuelven problemas hoy, sino que definen el éxito del mañana.',
    items: {
      '01': {
        title: 'Marketing Estratégico',
        description: 'Transformamos tu visión en resultados tangibles mediante análisis de datos, posicionamiento de marca y estrategias de crecimiento acelerado.',
        list: ['Investigación de mercado', 'Branding & Identidad', 'Growth Hacking', 'Estrategia de contenidos'],
      },
      '02': {
        title: 'Innovación Digital',
        description: 'Diseñamos y desarrollamos productos digitales que rompen esquemas, utilizando tecnología de vanguardia para crear experiencias memorables.',
        list: ['Diseño de productos UX/UI', 'Desarrollo de ecosistemas digitales', 'Transformación tecnológica', 'IA aplicada al marketing'],
      },
      '03': {
        title: 'Performance & Leads',
        description: 'Construimos infraestructuras de captación de alta eficiencia para convertir audiencias en clientes leales de forma escalable.',
        list: ['Generación de leads B2B/B2C', 'Ads & Social Media', 'Optimización de conversiones (CRO)', 'Email marketing automatizado'],
      },
      '04': {
        title: 'E-commerce & Ventas',
        description: 'Optimizamos cada punto de contacto del proceso de compra para maximizar el retorno de inversión en canales digitales.',
        list: ['Plataformas de venta online', 'Automatización de ventas', 'Analítica avanzada', 'Estrategias de retención'],
      },
    },
    cta: {
      title: '¿Listo para elevar tu <span class="italic text-gray-400">Estrategia?</span>',
      button: 'Hablemos de tu proyecto',
    },
  },
  contact: {
    subtitle: 'Hablemos',
    title: 'Contacto',
    highlight: 'Directo',
    description: 'Estamos aquí para transformar tus ideas en estrategias de marketing e innovación de alto impacto. Cuéntanos sobre tu proyecto y descubramos cómo podemos escalar juntos.',
  },
  footer: {
    cta: {
      title: 'Construyamos',
      highlight: 'juntos.',
      button: 'Contáctanos',
    },
    social: {
      title: 'Redes Sociales',
    },
  },
};
